var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ASDFADFdark-mode",
      class: { "overflow-x-hidden": this.resultPage.isMobile },
      attrs: { id: "app" },
    },
    [
      _c("delete-job-modal"),
      _vm._v(" "),
      _c("share-modal"),
      _vm._v(" "),
      _c("share-qr-code-modal"),
      _vm._v(" "),
      _vm.resultPage.isMobile === false
        ? _c("BaseLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "topbar",
                  fn: function () {
                    return [_c("router-view", { attrs: { name: "Topbar" } })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarLeft" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas-ad",
                  fn: function () {
                    return [
                      !_vm.isPremiumUser
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center banner-ad-size",
                            },
                            [_c("div", { attrs: { id: _vm.adId } })]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary-nav",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "secondary-nav" },
                        [
                          _c("router-view", {
                            attrs: { name: "SecondaryNav" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas",
                  fn: function () {
                    return [_c("router-view")]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-right",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarRight" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2946235630
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultPage.isMobile === true
        ? _c("MobileLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "main-canvas",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "MobileDefault" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "mobile-secondary-navbar",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "MobileSecondaryNavbar" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "mobile-navbar",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "MobileNavbar" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1958303328
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }